import { render, staticRenderFns } from "./homelibreria.vue?vue&type=template&id=2840222a&scoped=true"
import script from "./homelibreria.vue?vue&type=script&lang=js"
export * from "./homelibreria.vue?vue&type=script&lang=js"
import style0 from "./homelibreria.vue?vue&type=style&index=0&id=2840222a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840222a",
  null
  
)

export default component.exports